import {
  getItem as sessionStorageGetItem,
  setItem as sessionStorageSetItem,
  removeItem as sessionStorageRemoveItem,
} from './sessionStorageUtils';
import LZString from 'lz-string';

export const getItem = (name, decompress = false) => {
  try {
    let serializedItem = localStorage.getItem(name);

    if (serializedItem !== null) {
      if (decompress === true) serializedItem = LZString.decompressFromUTF16(serializedItem);

      return JSON.parse(serializedItem);
    }

    return sessionStorageGetItem(name, decompress);
  } catch (err) {
    return undefined;
  }
};

export const getItemWithExpiry = (name) => {
  const itemStr = localStorage.getItem(name);

  if (!itemStr) {
    return undefined;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return undefined
    localStorage.removeItem(name);
    return undefined;
  }
  return item.value;
};

export const removeItem = (name) => {
  try {
    localStorage.removeItem(name);
    sessionStorageRemoveItem(name);
  } catch (err) {
    console.error('removeItem', err);
  }
};

export const setItem = (name, value, compress = false) => {
  try {
    let serializedItem = JSON.stringify(value);
    if (compress === true) serializedItem = LZString.compressToUTF16(serializedItem);

    localStorage.setItem(name, serializedItem);
  } catch (err) {
    try {
      sessionStorageSetItem(name, value, compress);
    } catch (err) {
      console.error('setItem', err);
    }
  }
};

export const setItemWithExpiry = (name, value, days) => {
  const now = new Date();

  let ttl = 1000 * 60 * 60 * 24 * days;

  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };

  localStorage.setItem(name, JSON.stringify(item));
};

export const key = (index) => {
  return localStorage.key(index);
};

export const getLength = () => {
  return localStorage.length;
};

export default {
  getItem,
  setItem,
  removeItem,
  key,
  get length() {
    return getLength();
  },
};
